module.exports = __webpack_public_path__ + "img/misc-shipping.3a06756.svg";